export const IPEN_ENHANCED = 'data-ipen-enhanced';
